import { isAndroid, isiOS } from './is'

export function openWindow(
  url: string,
  opt?: { target?: TargetContext | string, noopener?: boolean, noreferrer?: boolean }
) {
  const { target = '__blank', noopener = true, noreferrer = true } = opt || {}
  const feature: string[] = []

  noopener && feature.push('noopener=yes')
  noreferrer && feature.push('noreferrer=yes')

  if (isAndroid) {
    const tempLink = document.createElement('a')
    tempLink.style.display = 'none'
    tempLink.href = url
    // tempLink.target = target
    document.body.appendChild(tempLink)
    tempLink.click()
    document.body.removeChild(tempLink)
  } else if (isiOS()) {
    window.location.href = url
  } else {
    window.open(url, target, feature.join(','))
  }
}

/**
 * 检验URL链接是否有效*** XMLHttpRequest
 * @param URL string
 * @returns
 */
export function getXMLUrlState(URL: string) {
  const getXmlHttpRequest = () => {
    if (window.XMLHttpRequest) {
      return new XMLHttpRequest()
    } else if (window.ActiveXObject) {
      return new ActiveXObject('microsoft.xmlHttp')
    }
  }
  const xmlHttp = getXmlHttpRequest() as XMLHttpRequest
  xmlHttp.open('GET', URL, false)
  xmlHttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
  xmlHttp.withCredentials = true
  try {
    xmlHttp.send()
  } catch (e) {
  } finally {
    const result = xmlHttp.responseText
    if (result) {
      if (xmlHttp.status === 200) {
        // eslint-disable-next-line no-unsafe-finally
        return true
      } else {
        // eslint-disable-next-line no-unsafe-finally
        return false
      }
    } else {
      // eslint-disable-next-line no-unsafe-finally
      return false
    }
  }
}

/**
 * 判断window.open打开页面是否被拦截
 * @return {boolean} true表示被拦截，false表示未被拦截
 */
export function isWindowOpenBlocked(val: Window | null) {
  let isBlocked = false
  try {
    if (val == null) { // 浏览器拦截
      isBlocked = true
    }
  } catch (e) {
    isBlocked = true // 插件、应用拦截
  }
  return isBlocked
}

/**
 * 获取url参数中指定参数的值
 * @param name 参数名
 * @returns
 */
export function getQueryString(name: string) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

/**
 * 判断url是否是https
 * @param {string} path
 * @returns {Boolean}
 */
export function isHttps(url: string) {
  if (!url) return false
  return url.indexOf('https://') !== -1
}

/**
 * 检测是否为合法的url
 * @param strUrl
 */
export function isUrl(path: string): boolean {
  const reg = /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/
  return reg.test(path)
}

/**
 * 获取当前 URL 的查询参数并以对象形式返回。
 * 如果传入了外部 URL，将从外部 URL 获取参数。
 * @param externalUrl - 可选的外部 URL
 * @returns 一个包含 URL 参数的对象
 */
export const urlParam2Obj = (externalUrl?: string): Record<string, string> => {
  let url: URL

  try {
    // 如果传入了外部 URL，尝试解析它
    if (externalUrl) {
      url = new URL(externalUrl)
    } else {
      // 否则使用当前窗口的 URL
      url = new URL(window.location.href)
    }
  } catch (error) {
    console.error('Invalid URL provided:', externalUrl)
    return {}
  }

  const params = new URLSearchParams(url.search)
  const paramObject: Record<string, string> = {}

  // 遍历所有的 URL 参数
  params.forEach((value, key) => {
    paramObject[key] = value
  })

  return paramObject
}

/**
 * 读取URL
 * @param url
 * @param method
 * @param headers
 * @returns
 */
export const readURL = (url: string, method = 'GET', headers: Record<string, string> = {}): Promise<XMLHttpRequest> => {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest()
    request.open(method, url)
    Object.keys(headers).forEach((key) => {
      request.setRequestHeader(key, headers[key])
    })
    request.onload = () => {
      if (request.status === 200) {
        try {
          resolve(request)
        } catch (e) {
          reject(new Error('Response parsing failed'))
        }
      } else {
        reject(new Error('Read error'))
      }
    }

    request.onerror = () => {
      reject(new Error('Request failed, please check your network or contact the developer'))
    }

    request.ontimeout = () => {
      reject(new Error('Request timed out, please try again'))
    }

    request.send()
  })
}
